<template>
  <div class="layout_index">
    <div class="main">
      <div class="layout_index_left">
        <div
          @click="menuSelect('/home')"
          style="text-align: center;
                            padding: 20px 0px;
                            height: 96px;
                            line-height: 96px;
                            overflow: hidden;
                            cursor: pointer;
                          "
        >
          <img
            style="width: 64px"
            src="offline.png"
            alt=""
          />
        </div>
        <div class="userTab">
          <div class="userTabContent">
            <!-- <img
              style="width: 30px; border-radius: 5px"
              :src="computedImg"
              alt=""
            /> -->
            <div class="avator">{{
              computedAvatar }}</div>
            <span
              style="font-size: 14px"
            >{{
              loginName }}</span>
            <img
              class="disconnect-icon"
              @click="logout"
              src="disconnect.png"
              style="width: 20px"
              alt=""
            />
          </div>
        </div>
        <div
          style="overflow: hidden; height: 100%"
        >
          <div style="
            width: 100%;
            height: calc(100% - 156px);
            overflow-y: auto;
            overflow-x: hidden;
            margin-right: -6px;">
            <el-menu
              :default-active="routerName"
              @select="menuSelect"
              class="el-menu-vertical-demo"
            >
              <el-menu-item
                class="single_menu"
                index="/home"
                v-has="[1, 0]"
              >
                <span
                  class="el-icon-house"
                  style="font-weight: bold"
                ></span>
                <span slot="title">
                  首页
                </span>
              </el-menu-item>
              <el-submenu
                index="/invest"
                class="el-submenu-demo"
                v-has="[100, 500, 0]"
              >
                <template slot="title">
                  <img
                    class="iconfont"
                    src="invest.png"
                    width="16px"
                    height="16px"
                  />
                  <span>客户资金</span>
                </template>
                <el-menu-item
                  index="/investOrder"
                >充值单</el-menu-item>
                <el-menu-item
                  index="/finaceOverdueOrder"
                >逾期审批</el-menu-item>
                <el-menu-item
                  index="/orderFlow"
                >订单流水</el-menu-item>
                <el-menu-item
                  index="/fundFlow"
                >资金流水</el-menu-item>
                <el-menu-item
                  index="/productFlow"
                >客户采购</el-menu-item>
                <el-menu-item
                  index="/periodFlow"
                >账期流水</el-menu-item>
                <el-menu-item
                  index="/finaceAduit/inovice/financeInvoice"
                >发票回传</el-menu-item>
              </el-submenu>
              <el-submenu
                index="/tickets"
                class="el-submenu-demo"
                v-has="[100, 300, 0]"
              >
                <template slot="title">
                  <span
                    class="iconfont icon-dingdan"
                  ></span>
                  <span>一件代发单</span>
                </template>
                <el-menu-item
                  index="/order"
                >审批流</el-menu-item>
                <el-menu-item
                  index="/overdueOrder"
                >发起还款</el-menu-item>
                <el-menu-item
                  index="/shipping"
                >邮费模板</el-menu-item>
                <el-menu-item
                  index="/brandManage"
                >品牌管理</el-menu-item>
                <el-menu-item
                  index="/productSeries"
                >商品系列</el-menu-item>
                <el-menu-item
                  index="/brandDiscount"
                >品牌折扣</el-menu-item>
                <el-menu-item
                  index="/outBond"
                >出库管理</el-menu-item>
              </el-submenu>
              <el-submenu
                index="/product"
                class="el-submenu-demo"
                v-has="[100, 200, 0]"
              >
                <template slot="title">
                  <span
                    class="iconfont icon-chanpin"
                  ></span>
                  <span>采购管理</span>
                </template>
                <el-menu-item
                  index="/pricePreset"
                >价格预设</el-menu-item>
                <el-menu-item
                  index="/productManager"
                >商品管理</el-menu-item>
                <el-menu-item
                  index="/warehouse"
                >采购仓库</el-menu-item>
              </el-submenu>
              <el-submenu
                index="/"
                class="el-submenu-demo"
                v-has="[100, 400, 0]"
              >
                <template slot="title">
                  <span
                    class="iconfont icon-wode"
                  ></span>
                  <span>系统管理</span>
                </template>
                <el-menu-item
                  index="/sysUser"
                >普通用户</el-menu-item>
              </el-submenu>
              <el-submenu
                index="/admin"
                class="el-submenu-demo"
                v-has="[100, 0]"
              >
                <template slot="title">
                  <span
                    class="iconfont icon-kefu"
                  ></span>
                  <span>管理员管理</span>
                </template>
                <el-menu-item
                  index="/adminUser"
                >管理用户</el-menu-item>
              </el-submenu>
              <el-submenu
                index="/fenxiaoExtend/invoice"
                class="el-submenu-demo"
                v-has="[100, 300, 0]"
              >
                <template slot="title">
                  <span
                    class="el-icon-coin"
                  ></span>
                  <span>高级工具</span>
                </template>
                <el-menu-item
                  index="/fenxiaoExtend/invoice"
                >发票申请</el-menu-item>
              </el-submenu>
              <el-menu-item
                class="single_menu"
                index="/purchase"
                v-has="[1, 0]"
              >
                <span
                  class="iconfont icon-dianpu"
                ></span>
                <span slot="title">
                  系统采购
                </span>
              </el-menu-item>
              <el-menu-item
                class="single_menu"
                index="/diy"
                v-has="[1,0]"
              >
                <span
                  class="el-icon-sold-out"
                  style="font-weight: bold"
                ></span>
                <span
                  slot="title">自助下单</span>
              </el-menu-item>
              <el-menu-item
                class="single_menu"
                index="/myOrder"
                v-has="[1, 0]"
              >
                <span
                  class="iconfont icon-gouwuche"
                ></span>
                <span slot="title">
                  我的代发单
                </span>
              </el-menu-item>
              <el-menu-item
                class="single_menu"
                index="/userSetup/changePassword"
                v-has="[100, 200, 300, 400, 500, 600, 700, 1, 0]"
              >
                <span
                  class="iconfont icon-shezhi"
                ></span>
                <span
                  slot="title">个人设置</span>
              </el-menu-item>
              <el-menu-item
                class="single_menu"
                index="/fenxiaoExtendAdvance/invoiceRequest"
                v-has="[1, 0]"
              >
                <span
                  class="el-icon-coin"
                ></span>
                <span
                  slot="title">工具</span>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
      </div>

      <div class="layou_index-content">
        <div class="content-wrapper">
          <div id="fenxiao_extend_container"></div>
          <transition
            name="fade-transform"
            mode="out-in"
          >
            <router-view
              :key="routerName"
            />
          </transition>
        </div>
      </div>
      <el-dialog
        title="检测到您是初始密码，请先修改密码"
        :visible.sync="updatePasswordDialog"
        width="20%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="updatePasswordClass"
        center
      >
        <change-password
          @closeDialog="closeDialog"
        ></change-password>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getUserSectionInfoByToken } from "api/user";
import ChangePassword from "views/userSetup/changePassword/index.vue";
import { ref, computed, onBeforeMount, onMounted, nextTick, unref, onUnmounted } from "@vue/composition-api";
import { currentPurchase, currentNormalUser } from "utils/auth"
export default {
  name: "LayoutIndex",
  components: { ChangePassword },
  setup(props, { root }) {
    /* data */
    const updatePasswordDialog = ref(false);
    const needExpend = ref(false)
    const formatterAvatar = (avatar) => avatar.substring(0, 1).toUpperCase()
    /* computed */
    const routerName = computed(() => {
      if (root.$store.state.user.layoutPath) {
        return root.$store.state.user.layoutPath;
      } else {
        if (root.$route.path.split("/")[1] == "userSetup") {
          return `/${root.$route.path.split("/")[1]}/changePassword`;
        } else if(root.$route.path.split("/")[1] == "fenxiaoExtendAdvance") {
          return `/${root.$route.path.split("/")[1]}/invoiceRequest`;
        } else if(root.$route.path.split("/")[1] == "fenxiaoExtend") {
          return `/${root.$route.path.split("/")[1]}/invoice`;
        } else if(root.$route.path.split("/")[1] == "finaceAduit") {
          return `/${root.$route.path.split("/")[1]}/inovice/financeInvoice`;
        } else {
          return `/${root.$route.path.split("/")[1]}`;
        }
      }
    });
    const loginName = computed(() => root.$store.state.user.name);
    const wx = root.$store.getters.wx;
    const computedAvatar = computed(() =>
      formatterAvatar(root.$store.state.user.name)
    );
    const currentPurchaseComputed = computed(() => currentPurchase())
    const currentNormalUserComputed = computed(() =>
      currentNormalUser())

    /* methods */
    const menuSelect = async (index) => {
      console.log(index);
      await root.$store.dispatch("user/layoutPathChange", index);
      root.$router.push({ path: index });
      if (needExpend.value) {
        Array.from(document.getElementsByClassName("el-menu-item")).forEach(element => {
          element.style.borderRight = "unset"
        });
        // const active = document.getElementsByClassName("is-active")[1];
        // active ? active.style.borderRight = "10px solid #477cff" : ''
      }
    };
    const logout = () => {
      if (root.$route.path == "/login") return;
      root.$store.dispatch("user/logout").then(() => {
        root.$router.push({ path: "/login" });
      });
    };
    /* 判断页面任意位置被点击过，重置倒计时秒数，否则时间一到，退到登录页 */
    function debounce(fn, wait) {
      let time = null;
      return function () {
        if (time) clearTimeout(time);
        if (root.$route.path != "/login") time = setTimeout(fn, wait);
      };
    }
    function handle() {
      let doms = document.getElementsByClassName("el-message")[0];
      if (doms) doms.remove();
      logout();
    }
    function closeDialog() {
      updatePasswordDialog.value = false;
    }
    /* lifecycle */
    onBeforeMount(async () => {


      /* 已在此页面不需要提示跳转 */
      if (root.$route.path != "/userSetup") {
        getUserSectionInfoByToken().then((res) => {
          const { email, passwordChanged } = res.data;
          if (passwordChanged != 1) {
            updatePasswordDialog.value = true;
          } else {
            /* 管理员不用去检查资料是否有填写 */
            // if (root.$store.state.user.roles.includes(1)) {
            //   if (!email) {
            //     root.$alert("检测到登录用户未完善个人信息!", "温馨提示", {
            //       confirmButtonText: "立即完善",
            //       showClose: false,
            //       closeOnClickModal: false,
            //       closeOnPressEscape: false,
            //       type: "warning",
            //       callback: () => {
            //         root.$router.push({ path: "/userSetup/changeUserInfo" });
            //       },
            //     });
            //   }
            // }
          }
        });
      }
    });
    onMounted(() => {
      window.addEventListener("click", debounce(handle, 1000 * 60 * 30));
      nextTick(() => {
        const menu = document.getElementsByClassName("el-menu-vertical-demo")
        const menuHeight = menu[0].clientHeight
        const parentHeight = menu[0].parentElement.clientHeight
        if (menuHeight <= parentHeight) {
          needExpend.value = true
        }
      })
    });
    return {
      updatePasswordDialog,
      routerName,
      loginName,
      computedAvatar,
      currentPurchaseComputed,
      currentNormalUserComputed,
      menuSelect,
      logout,
      closeDialog,
      needExpend
    };
  },
};
</script>
<style></style>
<style lang="scss" scoped>
.layout_index {
  width: 100%;
  height: 100%;
  // padding: 20px;
  background-color: #f3f5f9;
  font-size: 0;
  overflow: hidden;

  .layout_index_header {
    background: #409eff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 50px;
    height: 70px;
    overflow: auto;

    .el-dropdown-link {
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 20px;

      span {
        margin-left: 5px;
      }
    }

    .el-avatar--icon {
      font-size: 33px;
      width: 50px;
      height: 50px;
      line-height: 50px;
    }
  }

  .main {
    width: 100%;
    height: 100%;
    display: flex;
    background-color: #F3F4F9;
    border-radius: 10px;
    box-shadow: 4px 8px 16px rgb(0 0 0 / 15%);
    border-image: linear-gradient(135deg, #e6e6e6, transparent);

    .updatePasswordClass {
      .el-dialog__body {
        padding: 10px 20px !important;

        .password_reset {

          /* 仅适用于此文件 */
          ::v-deep .el-form {
            width: 100%;

            .el-form-item {
              margin-bottom: 10px;
            }

            .el-form-item+.el-form-item {
              margin-bottom: 20px;
            }
          }

          text-align: center;

          ::v-deep .dialog-footer {
            .el-button {
              width: 100%;
            }
          }
        }
      }
    }
  }

  .layout_index_left {
    min-width: 200px;
    height: 100%;
    position: relative;
    display: inline-block;
    background-color: #ffffff;
    // border-radius: 10px 0 0 10px;

    .userTab {
      padding: 0 10px;
      width: 100%;
      margin-bottom: 20px;
    }

    .userTabContent {
      background-color: #fff;
      overflow: hidden;
      padding: 5px;
      border-radius: 5px;
      cursor: pointer;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .avator {
        background-color: #498FE3;
        border-radius: 50%;
        width: 35px;
        height: 35px;
        color: #fff;
        text-align: center;
        font-size: 20px;
        line-height: 35px;
      }
    }

    .userTab .userTabContent {
      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.214);
    }

    ::v-deep .el-menu {
      background-color: transparent;
      border: 0;

      .single_menu {
        height: 45px;
        line-height: 45px;
      }

      &>li {
        text-align: left;
        margin: 8px 0;

        &.el-submenu-demo .is-active {
          background-color: #c6d9f9;
          color: #477cff;
          border-right: 4px solid #477cff !important;
        }
      }

      .el-submenu-demo {
        .el-menu-item {
          padding-left: 60px !important;
        }
      }

      .el-menu-item [class^="iconfont"],
      .el-menu-item [class^=el-icon-],
      .el-submenu__title [class^="iconfont"],
      .el-submenu__title [class^=el-icon-] {
        margin-right: 15px;
      }

      .el-menu-item [class^="el-icon"], .el-submenu__title [class^=el-icon-] {
        width: unset !important;
      }

    }
  }

  .layou_index-content {
    flex: 1;
    position: relative;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: auto;

    .content-wrapper {
      width: 100%;
      height: 100%;
    }
  }
}

::v-deep .el-menu {
  .el-submenu__title {
    height: 40px;
    line-height: 40px;
  }

  .el-menu--inline {
    margin-top: 3px;
  }

  .el-submenu .el-menu-item,
  .el-menu-item {
    height: 35px;
    line-height: 35px;

    &.is-active {
      background-color: #c6d9f9;
      color: #477cff
    }
  }


  .el-submenu-demo {
    .is-active {
      background-color: #c6d9f9;
      color: #477cff
    }
  }
}

.el-menu {
  .is-opened {
    ::v-deep .el-submenu__title {
      // background-color: #475cff;
      // color: #fff;
    }
  }
}

::v-deep .el-submenu__icon-arrow {
  display: none;
}
</style>
